import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/nanaData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex cursor-pointer items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <h1 className="font-[ZCOOL_KuaiLe] text-xl text-foreground-950">
            娜娜51<span className="text-primary-500">热评圈</span>
          </h1>
        </button>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                goTo(link.href);
              }}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => goTo("#comments")}
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            围观热评
          </button>
          <button
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(link.href);
                }}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}